module.exports = __webpack_public_path__ + "img/old_portfolio_canvas.7b76d5e9.png";